function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8096"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7906"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 24",
  d: "M79.104 140.002a.967.967 0 01-.062-.151c-.063.114-.017.14.062.151",
  fill: "#a1dbd3"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 28",
  d: "M70 134.41c38.659 0 70-30.09 70-67.207S108.659.003 70 .003 0 30.09 0 67.203s31.341 67.207 70 67.207",
  fill: "#e8f6f4"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7909"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 29",
  d: "M67.452 83.827a1.438 1.438 0 001.01.4 1.511 1.511 0 001.01-.4l6.9-6.625a1.326 1.326 0 000-1.926 1.461 1.461 0 00-2.009 0l-5.889 5.655-2.8-2.692a1.463 1.463 0 00-2.006 0 1.325 1.325 0 000 1.929z",
  fill: "#a1dbd3"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7910"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 30",
  d: "M34.436 94.097a6.163 6.163 0 006.275 6.02h58.582a6.165 6.165 0 006.275-6.024v-35.14H34.436zM70 65.537c8.053 0 14.6 6.284 14.6 14S78.055 93.552 70 93.552s-14.594-6.283-14.594-14.015 6.542-14 14.595-14",
  fill: "#a1dbd3"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7911"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 31",
  d: "M48.845 50.391h7.513a1.4 1.4 0 001.42-1.366V35.653a1.4 1.4 0 00-1.42-1.366h-7.513a1.4 1.4 0 00-1.423 1.366v13.372a1.4 1.4 0 001.423 1.366",
  fill: "#a1dbd3"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7912"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 32",
  d: "M99.291 40.967h-3.869v8.058a4.2 4.2 0 01-4.269 4.1h-7.5a4.2 4.2 0 01-4.266-4.1v-8.058H60.626v8.058a4.2 4.2 0 01-4.269 4.1h-7.513a4.2 4.2 0 01-4.266-4.1v-8.058h-3.869a6.164 6.164 0 00-6.275 6.036v9.22h71.132v-9.22a6.166 6.166 0 00-6.275-6.036z",
  fill: "#a1dbd3"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7913"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 33",
  d: "M83.657 50.391h7.5a1.392 1.392 0 001.421-1.366V35.653a1.392 1.392 0 00-1.423-1.366h-7.498a1.39 1.39 0 00-1.423 1.366v13.372a1.39 1.39 0 001.423 1.366",
  fill: "#a1dbd3"
})));
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140
  }, props), _ref);
};
export default SvgCalendar;